import React from "react";
import { motion } from "framer-motion";
import { SparklesIcon, ShieldCheckIcon, TimerIcon, HeartIcon, TrendingUpIcon, BoxIcon } from "lucide-react";
interface Outcome {
  icon: BoxIcon;
  title: string;
  text: string;
}
const OUTCOMES: Outcome[] = [{
  icon: SparklesIcon,
  title: 'Clases más profesionales',
  text: 'Aprendé a estructurar sesiones completas de principio a fin sin depender de la inspiración del momento.'
}, {
  icon: ShieldCheckIcon,
  title: 'Más seguridad al enseñar',
  text: 'Adaptá ejercicios para distintos alumnos con criterios claros y sin improvisar.'
}, {
  icon: TimerIcon,
  title: 'Menos tiempo planificando',
  text: 'Accedé a clases listas, recursos prácticos y herramientas para ahorrar horas de preparación.'
}, {
  icon: HeartIcon,
  title: 'Alumnos más satisfechos',
  text: 'Creá clases dinámicas, variadas y mejor organizadas que inviten a volver.'
}, {
  icon: TrendingUpIcon,
  title: 'Más confianza como profesional',
  text: 'Enseñá con la tranquilidad de saber qué hacer ante cualquier situación que aparezca en clase.'
}];
export function Outcomes() {
  return <section className="w-full bg-brown-dark py-20" data-id="element-116" data-mp="2xy5434terfpb">
      <div className="mx-auto max-w-6xl px-6" data-id="element-117" data-mp="2y0r9oywqnl4w">
        <div className="mx-auto max-w-2xl text-center" data-id="element-118" data-mp="2t6n1ydfnf92r">
          
          <h2 className="mt-5 font-serif text-4xl font-semibold leading-[1.05] text-beige sm:text-5xl" data-id="element-119" data-mp="2p6393m23yrmf">
            Lo que vas a lograr con Pilates Resuelto
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-beige/70 sm:text-lg" data-id="element-120" data-mp="2k4xaj7lroa4z">
            Más claridad para planificar y la confianza para responder en cada clase.
          </p>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-121" data-mp="2aangzml395so">
          {OUTCOMES.map(({
          icon: Icon,
          title,
          text
        }, i) => <motion.article key={title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i % 3 * 0.08
        }} className="rounded-2xl bg-beige/5 p-7 ring-1 ring-beige/10 backdrop-blur" data-id="element-122" data-mp="8g619hb5h3wz" data-mpi={i}>
              <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-brown-light text-beige" data-id="element-123" data-mp="1oz7tecszpa6t">
                <Icon className="h-6 w-6" strokeWidth={1.75} data-id="element-124" data-mp="1szrozbxx05qu" />
              </div>
              <h3 className="font-serif text-xl font-semibold text-beige" data-id="element-125" data-mp="2gqduowkg5dxo">
                {title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-beige/70" data-id="element-126" data-mp="2lne1j9p4ekpu">
                {text}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}